import { useCallback } from 'react'
import { useIntl } from 'react-intl'

function useTranslate() {
  const { formatMessage } = useIntl()

  const translate = useCallback(
    (message, values) => {
      if (Array.isArray(message)) {
        return formatMessage(message[0], message[1])
      }

      if (message?.id) {
        return formatMessage(message, values)
      }
      return message
    },
    [formatMessage],
  )

  return translate
}

export const TODO_translate = null
export default useTranslate
